export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11157.3c9b237b.jpg";